import shipList from "./shipList";
import regionList from "./regionList";

export const initialFilters = {
  nights: [
    { value: "1-3", label: "1 - 3 nights", checked: false },
    { value: "4-7", label: "4 - 7 nights", checked: false },
    { value: "8-12", label: "8 - 12 nights", checked: false },
    { value: "13", label: "13 + nights", checked: false },
  ],
  categoryClass: [
    { value: "I", label: "I - Insider", checked: false },
    { value: "O", label: "O - Sea View", checked: false },
    { value: "B", label: "B - Terrace", checked: false },
    { value: "S", label: "S - Rock Star Suite", checked: false },
  ],
  regionList: regionList,
  shipList: shipList,
  excludeSoldOut: true,
};
